import React, { useEffect, useState } from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import { IconWithText } from '../styles/components';
import { useTabPersistedState } from '../tabPersistedState/tab-persisted-state';

interface TabConfig {
  label: string;
  content: React.ReactNode;
  disabled?: boolean;
  icon?: React.ReactNode;
}

type Orientation = 'horizontal' | 'vertical';

interface TabsLayoutProps {
  sections: TabConfig[];
  orientation?: Orientation; // Optional, defaults to vertical
  source: string;
  persistOnSwitch?: boolean;
}

export default function TabsLayout({
  sections,
  orientation = 'vertical',
  source,
  persistOnSwitch
}: TabsLayoutProps) {

  const [selectedTab, setSelectedTab] = useTabPersistedState(`${source}-tab-index`, 0);
  const [visitedTabs, setVisitedTabs] = useState<Set<number>>(new Set);



  const isVertical = orientation === 'vertical';

  const allowedSections = sections.filter(item => !item.disabled);

  useEffect(()=>{
    if (persistOnSwitch) {
      setVisitedTabs((prev)=>new Set([...Array.from(prev), selectedTab]))
    } else {
      setVisitedTabs(new Set([selectedTab]));
    }
  }, [selectedTab])

  return (
    <Box
      sx={{
        display: isVertical ? 'flex' : 'block',
        bgcolor: 'background.paper',
      }}
    >
      <Tabs
        orientation={orientation}
        variant="scrollable"
        value={selectedTab}
        onChange={(e, v)=> setSelectedTab(v)}
        sx={{
          ...(isVertical
            ? { borderRight: 1, borderColor: 'divider', minWidth: 150 }
            : { borderBottom: 1, borderColor: 'divider' }),
        }}
      >
        {allowedSections.map((section, index) => (
          <Tab key={index} label={section.icon ? <IconWithText>{section.icon}{section.label}</IconWithText> : section.label} />
        ))}
      </Tabs>
      {
          allowedSections.map((sec, idx) => visitedTabs.has(idx) && <Box sx={{ flexGrow: 1, p: 3,  display: idx == selectedTab ? 'block':'none' }} key={sec.label} >{sec.content}</Box>)
      }

      
    </Box>
  );
}
